import { Footer as LayoutFooter } from 'layout/components/footer/index';
import { IconChat, IconEmail, IconPhone } from 'ui/Icons';
import { customerIsCompany } from '@/helpers/customerUtils';
import { useSelector } from 'react-redux';
import { State } from '@/types/State';
import { getSelectedCustomer } from '@/app/slices/userSlice';
import { Box } from 'ui/mui';

declare const Cookiebot: { show: () => void };

const openEbbot = () => {
  if ((window as any).Ebbot && (window as any).Ebbot.show) {
    (window as any).Ebbot.show();
    (window as any).Ebbot.openChatWindow?.();
  }
};

export const MittMeFooter = () => {
  const selectedCustomer = useSelector((state: State) =>
    getSelectedCustomer(state),
  );
  const isCompany = customerIsCompany(selectedCustomer);

  return (
    <Box data-clarity-unmask='True'>
      <LayoutFooter
        maxWidth={1200}
        list1={{
          title: 'Kontakt',
          items: [
            {
              icon: <IconPhone />,
              text: 'Ring oss:',
              href: isCompany ? 'tel:021395200' : 'tel:021395050',
              linkText: isCompany ? '021 39 52 00' : '021 39 50 50',
            },
            {
              icon: <IconChat />,
              linkText: 'Chatta med oss',
              onClick: openEbbot,
            },
            {
              icon: <IconEmail />,
              href: '/profile?tab="tickets"',
              linkText: 'Skicka en fråga till oss',
            },
          ],
        }}
        list2={{
          title: 'Tjänster',
          items: [
            {
              href: '/profile?tab="disruption"',
              linkText: 'Avisering vid avbrott',
            },
            {
              href: 'https://www.malarenergi.se/avbrott/',
              linkText: 'Pågående avbrott',
              external: true,
            },
            {
              href: 'https://apps.malarenergi.se/avtal/flytta',
              linkText: 'Anmäl inflytt eller utflytt',
              external: true,
            },
            {
              href: 'https://apps.malarenergi.se/avtal/teckna',
              linkText: 'Teckna nytt elavtal',
              external: true,
            },
          ],
        }}
        bottomBarLinks={[
          {
            href: 'https://www.malarenergi.se/om-webbplatsen/',
            text: 'Om webbplatsen',
            external: true,
          },
          {
            onClick: () => {
              if (typeof Cookiebot !== 'undefined') {
                Cookiebot.show();
              }
            },
            text: 'Hantering av Cookies',
          },
          {
            href: 'https://www.malarenergi.se/om-webbplatsen/gdpr/',
            text: 'Behandling av personuppgifter',
            external: true,
          },
          {
            href: 'https://www.malarenergi.se/',
            text: 'malarenergi.se',
            external: true,
          },
        ]}
      />
    </Box>
  );
};
